import React from "react";

import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";

// Desktop + Mobile hero images — imported separately
import HeroBgImg       from "../../asset/images/products/esp-management/hero-bg.webp";
import HeroBgImgMobile from "../../asset/images/products/esp-management/hero-bg-mobile.webp";

// Right column — single image
import ContentImg from "../../asset/images/products/esp-management/content-image.webp";

// Checkmark icon
import CheckIcon from "../../asset/images/products/esp-management/check-icon.svg";


const BULLETS = [
  "EPMS (EPMS – Data Management System) will be loaded on a PC. The EPMS operates on a Windows platform & uses well known Windows icons & buttons. This makes it easy for the users to operate the EPMS.",
  "The EPMS has multilevel security options & the access to the controls & parameters is on the basis of user operating levels such as Guest level, Operator level & Supervisor level. Through individual Login & passwords one can have access to the different operating & setting options depending upon his Login level status.",
  "This security levels makes the whole software user friendly at the same time with the control on the access level of the user. This prevents unwanted or unknowingly or deliberate disturbing of the settings.",
  "Through the EPMS the overall control of the TR set & ESP auxiliaries is possible. The EPMS will control the TR sets through the DCSIM units.",
  "The DCSIM communicates with HFPS CONTROL controllers & the keypad display unit on a CAN bus link. While the DCSIM communicates with the outside devices on RS232/485 links using MODBUS RTU protocol with the optional profibus and Ethernet protocol conversions.",
  "With EPMS overall control of the TR sets is achieved. This includes switching on/off, setting of o/p parameters, display the o/p parameters, displaying of trends, VI curves, configuring & enabling/disabling of EMS (Energy Management System) based on opacity feedback.",
  "The PC will act as a Main operator station from where the complete ESP can be controlled, which includes the TR's, Rappers & all the auxiliaries.",
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .epms-wrap { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .epms-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    background: #111;
  }
  .epms-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .epms-hero-bg-mobile {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: none;
  }
  .epms-hero-overlay {
    position: absolute;
    inset: 0;
  }
  .epms-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .epms-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 700;
    color: #fff;
    line-height: 120%;
    margin-bottom: 15px;
  }
  .epms-hero-divider {
    width: 420px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 18px;
  }
  .epms-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 150%;
    max-width: 400px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .epms-breadcrumb {
    padding: 40px 0 0 0;
  }
  .epms-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .epms-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .epms-bc-item:hover { color: #EB2019; }
  .epms-bc-item.epms-active { color: #202020; }
  .epms-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .epms-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. CONTENT — left bullets + right gallery
  ══════════════════════════════════════════ */
  .epms-section-content {
    padding: 80px 0 120px 0;
  }
  .epms-content-grid {
    display: flex;
    gap: 130px;
    align-items: flex-start;
  }

  /* ── LEFT COLUMN ── */
  .epms-content-left {
    flex: 0 0 802px;
  }
  .epms-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  .epms-bullet-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .epms-bullet-item {
    display: flex;
    gap: 13px;
    align-items: flex-start;
  }
  .epms-check-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-top: 0px;
  }
  .epms-bullet-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ── RIGHT COLUMN — single image ── */
  .epms-gallery {
    flex: 1;
  }
  .epms-gallery img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 6px;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET 768px
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .epms-hero              { height: 300px; }
    .epms-hero-bg           { display: block; }
    .epms-hero-bg-mobile    { display: none; }
    .epms-hero-content      { padding: 0 32px; }
    .epms-hero-title        { font-size: 28px; }
    .epms-hero-divider      { width: 260px; }
    .epms-hero-desc         { font-size: 14px; }

    .epms-breadcrumb        { padding: 28px 0 0 0; }
    .epms-breadcrumb-inner  { padding: 0 32px; }
    .epms-inner             { padding: 0 32px; }

    .epms-section-content   { padding: 40px 0 60px 0; }
    .epms-content-grid      { flex-direction: column; gap: 40px; }
    .epms-content-left      { flex: none; width: 100%; }
    .epms-red-title         { font-size: 24px; margin-bottom: 24px; }
    .epms-bullet-text       { font-size: 14px; }
    .epms-check-icon        { width: 22px; height: 22px; }

    .epms-gallery img     { border-radius: 6px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .epms-hero              { height: 400px; }
    .epms-hero-bg           { display: none; }
    .epms-hero-bg-mobile    { display: block; }
    .epms-hero-content      { padding: 0 16px; }
    .epms-hero-title        { font-size: 24px; }
    .epms-hero-divider      { width: 100%; margin-bottom: 15px; }
    .epms-hero-desc         { font-size: 14px; }

    .epms-breadcrumb        { padding: 22px 0 0 0; }
    .epms-breadcrumb-inner  { padding: 0 16px; gap: 14px; }
    .epms-bc-item           { font-size: 14px; }
    .epms-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .epms-inner             { padding: 0 16px; }

    .epms-section-content   { padding: 30px 0 60px 0; }
    .epms-content-grid      { gap: 30px; }
    .epms-red-title         { font-size: 20px; margin-bottom: 30px; }
    .epms-bullet-item       { gap: 14px; }
    .epms-bullet-text       { font-size: 14px; }
    .epms-check-icon        { width: 16px; height: 16px; }
    .epms-bullet-list       { gap: 30px; }

    .epms-gallery img     { border-radius: 0px; }
  }
`;

export default function EspManagementSystem() {
  return (
    <div className="epms-wrap">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="epms-hero">
        <img className="epms-hero-bg"        src={HeroBgImg}       alt="" />
        <img className="epms-hero-bg-mobile" src={HeroBgImgMobile} alt="" />
        <div className="epms-hero-overlay" />
        <div className="epms-hero-content">
          <h1 className="epms-hero-title">ESP Management System</h1>
          <hr className="epms-hero-divider" />
          <p className="epms-hero-desc">
            The EPMS operates on a Windows platform & uses well known Windows icons & buttons. This makes it easy for the users to operate the EPMS.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="epms-breadcrumb" aria-label="Breadcrumb">
        <div className="epms-breadcrumb-inner">
          <a href="/" className="epms-bc-item">Home</a>
          <span className="epms-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="epms-bc-item">Products</a>
          <span className="epms-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="epms-bc-item epms-active">ESP Management System</span>
        </div>
      </nav>

      {/* ══ 3. CONTENT ══ */}
      <section className="epms-section-content">
        <div className="epms-inner">
          <div className="epms-content-grid">

            {/* Left — title + checkmark bullet list */}
            <div className="epms-content-left">
              <h2 className="epms-red-title">ESP Management System</h2>
              <ul className="epms-bullet-list">
                {BULLETS.map((text, i) => (
                  <li key={i} className="epms-bullet-item">
                    <img src={CheckIcon} alt="" className="epms-check-icon" />
                    <span className="epms-bullet-text">{text}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right — single image */}
            <div className="epms-gallery">
              <img src={ContentImg} alt="ESP Management System" />
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}